import { Link } from 'react-router-dom';
import { BrandLS } from './_BrandLS';
import { BrandLink } from '../../_Templates/_UI/_Shared/BrandLink';

const BLOCK = 'LStudio__app_footer';

export const AppFooterPublic = ({ brand, columns = [], legal, showBrandLS = false, isPrivate = false }) => {

    const SLOT = isPrivate ? brand?.footerPrivate : brand?.footerPublic;

    return (

    <footer className={BLOCK}>

        <div className={`${BLOCK}__grid`}>

            <div className={`${BLOCK}__brand_col`}>

                <BrandLink slot={SLOT} homePath={SLOT?.internalLink ?? "/"} className={`${BLOCK}__brand`} isLogo>

                    <img
                        src={brand?.logoLight || brand?.logoDark || ""}
                        alt={brand?.name || "APP"}
                        title={brand?.name || "APP"}
                        className={`${BLOCK}__logo ${BLOCK}__logo--light`}
                        onError={(e) => { e.currentTarget.style.display = "none"; }}
                    />

                    <img
                        src={brand?.logoDark || brand?.logoLight || ""}
                        alt={brand?.name || "APP"}
                        title={brand?.name || "APP"}
                        className={`${BLOCK}__logo ${BLOCK}__logo--dark`}
                        onError={(e) => { e.currentTarget.style.display = "none"; }}
                    />

                </BrandLink>

                {!isPrivate && brand?.claim && <p className={`${BLOCK}__claim`}>{brand.claim}</p>}
            </div>

            {
                columns.map((col) => (
                    <div key={col.title}>
                        <p className={`${BLOCK}__title`}>{col.title}</p>
                        {
                            col.items.map((item) => (
                                <Link key={item.path} to={item.path} className={`${BLOCK}__link`}>
                                    {item.label}
                                </Link>
                            ))
                        }
                    </div>
                ))
            }

        </div>

        <div className={`${BLOCK}__bottom`}>{legal}</div>

        {/* 🔥 Marca FIJA del autor del template. Nada que ver con la del cliente. */}
        {showBrandLS && <BrandLS />}

    </footer>
    );
};